import { Helmet } from 'react-helmet';
import { siteConfig } from '../config.js';
import EventsSectionA from '../components/EventsSectionA.js';
import Header from '../components/Header.js';
import PreFooter from '../components/PreFooter';
import Footer from '../components/Footer';

export default function EventsPage() {
  return (
    <>
      <Helmet>
        <title>Events | {siteConfig.title}</title>
        <meta name="description" content={siteConfig.metaDescription} />
      </Helmet>

      <Header config={siteConfig} />
        <EventsSectionA />  
      <PreFooter />
      <Footer/>
    </>
  );
}
